import React from 'react'

interface IProps {
  msg: String
}

const Error: React.FC<IProps> = ({ msg }) => {
  return <h3>{msg}</h3>
}

export default Error
